export default __webpack_public_path__ + "static/media/userIcon.b77c2604.svg";